import React, { useEffect, useRef, useState } from 'react';

/**
 * Компактный multi-select для панели фильтров ПО.
 */
const ProjectOfficeFilterMultiSelect = ({
  label,
  options,
  selected,
  onChange,
  emptyLabel = 'Все',
  minWidth = 160,
  testIdPrefix = 'po-filter',
}) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const selectedSet = selected instanceof Set ? selected : new Set(selected || []);

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDoc);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const toggle = (value) => {
    const next = new Set(selectedSet);
    if (next.has(value)) next.delete(value);
    else next.add(value);
    onChange(next);
  };

  const count = selectedSet.size;
  const buttonText = count === 0 ? `${label}: ${emptyLabel}` : `${label}: ${count}`;

  return (
    <div
      className="po-filter-dropdown"
      ref={rootRef}
      style={{ minWidth }}
      data-testid={`${testIdPrefix}-root`}
    >
      <button
        type="button"
        className="btn btn-outline-secondary btn-sm po-filter-dropdown__trigger"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        data-testid={`${testIdPrefix}-trigger`}
      >
        {buttonText}
        <span aria-hidden>{open ? ' ▴' : ' ▾'}</span>
      </button>
      {open && (
        <div
          className="glass-dropdown po-filter-dropdown__menu"
          data-testid={`${testIdPrefix}-menu`}
          onMouseDown={(e) => e.stopPropagation()}
        >
          {options.length === 0 ? (
            <div className="po-filter-dropdown__empty">Нет вариантов</div>
          ) : (
            options.map((opt) => {
              const value = typeof opt === 'string' ? opt : opt.value;
              const text = typeof opt === 'string' ? opt : opt.label;
              return (
                <label
                  key={value}
                  className="po-filter-dropdown__option"
                  data-testid={`${testIdPrefix}-option-${value}`}
                >
                  <input
                    type="checkbox"
                    checked={selectedSet.has(value)}
                    onChange={() => toggle(value)}
                  />
                  <span>{text}</span>
                </label>
              );
            })
          )}
        </div>
      )}
    </div>
  );
};

export default ProjectOfficeFilterMultiSelect;
